import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-LTMZH3LQ6K";
// const MEASUREMENT_ID = "G-VSB2S2GNN2";
ReactGA.initialize(MEASUREMENT_ID ? MEASUREMENT_ID : "");

export default ReactGA
